/* Afkar Plus — gift-box edits v2: tabs / counter, hover ↔ pointer (only the hovered one lights up), × removes a piece
   (price + add-all follow), "view each piece" = individual + buttons, "add the edit" multi-add (BeyondADS, 23 Sep 2026) */
(function () {
  'use strict';
  if (window.__abLoaded) return;
  window.__abLoaded = true;

  var routes = window.routes || {};
  var ADD = (routes.cart_add_url || '/cart/add') + '.js';

  function pad(n) { return ('0' + n).slice(-2); }

  function paintBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.shopify-section');
    el.innerHTML = inner ? inner.innerHTML : html;
  }

  function addItems(items) {
    return fetch(ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to the cart');
        paintBubble(res.body && res.body.sections);
        document.dispatchEvent(new CustomEvent('afkar:cart:updated', { detail: { items: items } }));
        return res.body;
      });
  }

  function flash(el, cls, ms) { el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms); }

  /* money: keep the symbol/format of the rendered price, swap the number */
  function money(sample, cents) {
    var num = (cents / 100).toFixed(2);
    if (/\d/.test(sample)) return sample.replace(/[\d.,]+/, num);
    return '$' + num;
  }

  function init(root) {
    if (root.__ab) return;
    root.__ab = true;

    var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-ab-scene]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ab-panel]'));
    var lists = Array.prototype.slice.call(root.querySelectorAll('[data-ab-list]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ab-tab]'));
    var cur = root.querySelector('[data-ab-cur]');
    var meet = root.querySelector('[data-ab-meet]');
    var n = scenes.length;
    var i = 0;

    function show(k) {
      i = ((k % n) + n) % n;
      scenes.forEach(function (s, j) { var on = j === i; s.classList.toggle('is-active', on); if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
      panels.forEach(function (p, j) { var on = j === i; p.classList.toggle('is-active', on); p.hidden = !on; });
      lists.forEach(function (l, j) { var on = j === i; l.classList.toggle('is-active', on); l.hidden = !on; });
      tabs.forEach(function (t, j) { var on = j === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      if (cur) cur.textContent = pad(i + 1);
      if (meet && panels[i] && panels[i].getAttribute('data-link')) meet.setAttribute('href', panels[i].getAttribute('data-link'));
    }

    /* hover: one pointer + its row light up together, nothing else */
    function hot(k, on) {
      root.querySelectorAll('.is-hot').forEach(function (el) { el.classList.remove('is-hot'); });
      if (!on) return;
      var sc = scenes[i], ls = lists[i], pn = panels[i];
      [sc, ls, pn].forEach(function (box) {
        if (!box) return;
        box.querySelectorAll('[data-ab-hot="' + k + '"],[data-ab-row="' + k + '"]').forEach(function (el) { el.classList.add('is-hot'); });
      });
    }
    ['mouseover', 'focusin'].forEach(function (ev) {
      root.addEventListener(ev, function (e) { var t = e.target.closest('[data-ab-row],[data-ab-hot]'); if (t) hot(t.getAttribute('data-ab-row') || t.getAttribute('data-ab-hot'), true); });
    });
    ['mouseout', 'focusout'].forEach(function (ev) {
      root.addEventListener(ev, function (e) { var t = e.target.closest('[data-ab-row],[data-ab-hot]'); if (t) hot(t.getAttribute('data-ab-row') || t.getAttribute('data-ab-hot'), false); });
    });

    /* the pieces that are still in the edit (× removes / restores) */
    function activeRows(k) {
      var ls = lists[k];
      return ls ? Array.prototype.slice.call(ls.querySelectorAll('[data-ab-row]')).filter(function (r) { return !r.classList.contains('is-removed'); }) : [];
    }
    function refresh(k) {
      var rows = activeRows(k), pn = panels[k];
      if (!pn) return;
      var cents = rows.reduce(function (s, r) { return s + (parseInt(r.getAttribute('data-price'), 10) || 0); }, 0);
      var price = pn.querySelector('[data-ab-price]');
      if (price) price.textContent = money(price.textContent, cents);
      var btn = pn.querySelector('[data-ab-addall]');
      if (btn) btn.disabled = rows.length === 0;
      var count = pn.querySelector('.ab-strip__count');
      if (count) count.textContent = count.textContent.replace(/^\d+/, rows.length);
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ab-tab]');
      if (tab) { e.preventDefault(); show(parseInt(tab.getAttribute('data-ab-tab'), 10) || 0); return; }

      var x = e.target.closest('[data-ab-remove]');
      if (x) {
        e.preventDefault();
        var row = x.closest('[data-ab-row]');
        var off = !row.classList.contains('is-removed');
        row.classList.toggle('is-removed', off);
        var k = row.getAttribute('data-ab-row');
        [scenes[i], panels[i]].forEach(function (box) { if (box) box.querySelectorAll('[data-ab-hot="' + k + '"],[data-ab-row="' + k + '"]').forEach(function (el) { el.classList.toggle('is-off', off); }); });
        refresh(i);
        return;
      }

      var alt = e.target.closest('[data-ab-alt]');
      if (alt) {
        e.preventDefault();
        var open = !root.classList.contains('is-individual');
        root.classList.toggle('is-individual', open);
        root.querySelectorAll('[data-ab-alt]').forEach(function (a) { a.setAttribute('aria-expanded', open ? 'true' : 'false'); });
        return;
      }

      var all = e.target.closest('[data-ab-addall]');
      if (all && !all.classList.contains('is-busy')) {
        e.preventDefault();
        var ids = activeRows(i).map(function (r) { return parseInt(r.getAttribute('data-variant'), 10); }).filter(Boolean);
        var msg = all.closest('[data-ab-panel]').querySelector('[data-ab-msg]');
        if (msg) { msg.hidden = true; msg.textContent = ''; }
        if (!ids.length) return;
        all.classList.add('is-busy');
        addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }))
          .then(function () { flash(all, 'is-added', 2200); })
          .catch(function (err) { if (msg) { msg.textContent = err.message || 'Could not add to the cart'; msg.hidden = false; setTimeout(function () { msg.hidden = true; }, 4000); } })
          .then(function () { all.classList.remove('is-busy'); });
        return;
      }

      var one = e.target.closest('[data-ab-add]');
      if (one && !one.classList.contains('is-busy')) {
        e.preventDefault();
        var vid = parseInt(one.getAttribute('data-variant'), 10);
        one.classList.add('is-busy');
        addItems([{ id: vid, quantity: 1 }])
          .then(function () { flash(one, 'is-added', 1600); })
          .catch(function (err) { one.setAttribute('title', err.message || 'Could not add to the cart'); })
          .then(function () { one.classList.remove('is-busy'); });
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.target.closest('[data-ab-tab]')) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); tabs[i].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); tabs[i].focus(); }
      }
    });

    show(0);
    root.__abShow = show;
  }

  function boot() { document.querySelectorAll('[data-ab]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
